import { useTranslation } from "next-i18next";
import Image from "next/image";

interface Props {
  onClose: () => void;
}

export default function ImageGuidelinesPopup({ onClose }: Props) {
    const {t} = useTranslation('common');
  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center">
      <div 
        className="bg-white w-[90%] max-w-[450px] rounded-2xl px-6 py-8 relative"
        onClick={(e) => e.stopPropagation()}
      >

        {/* Title */}
        <h2 className="text-center text-xl font-bold mb-4">{t('tipsHeading')}</h2>

        <div className="flex gap-2 items-center justify-center">

          {/* GOOD image */}
          <div className="flex flex-col items-center relative">
            <div className="w-[120px] h-[120px] rounded-xl overflow-hidden p-4">
              <Image src="/images/tips/good1.png" alt="good" fill className="object-cover" />
            </div>
            <div className="bg-[#4BB213] text-white flex item-center justify-center p-[2px] px-[8px] rounded-full absolute -bottom-4 right-0">
                <p className="object-cover font-black">✔</p>
            </div>
          </div>

          {/* BAD image */}
          <div className="flex flex-col items-center relative">
            <div className="w-32 h-32 rounded-xl overflow-hidden">
              <Image src="/images/tips/bad1.png" alt="bad" fill className="object-cover" />
            </div>
            <div className="bg-red-600 text-white flex item-center justify-center p-[2px] px-[8px] rounded-full absolute -bottom-3 right-0">
                <p className="object-cover font-black">✖</p>
            </div>
          </div>
        </div>

        <p className="text-center text-md mt-5 mb-2">
          {t('tipsSubHeading')}
        </p>

        {/* 3-row section */}
        <div className="grid grid-cols-2 gap-4 mt-4 text-center">
          <div>
            <div className="flex items-center justify-center gap-2 mb-2">
                <div className="flex flex-col items-center relative">
                    <Image src="/images/tips/good1.png" alt="bad" width={70} height={90} />
                    <div className="bg-[#4BB213] text-white flex item-center justify-center py-[1px] px-[6px] rounded-full absolute -bottom-2 right-0">
                        <p className="object-cover font-black text-[12px]">✔</p>
                    </div>
                </div>
                <div className="flex flex-col items-center relative">
                    <Image src="/images/tips/child-side-bad.png" alt="bad" width={75} height={95} />
                    <div className="bg-red-600 text-white flex item-center justify-center py-[1px] px-[6px] rounded-full absolute -bottom-2 right-0">
                        <p className="object-cover font-black text-[12px]">✖</p>
                    </div>
                </div>
            </div>
            <p className="mt-4 text-md">{t('tipsOne')}</p>
          </div>

          <div>
            <div className="flex items-center justify-center gap-2 mb-2">
                <div className="flex flex-col items-center relative">
                    <Image src="/images/tips/good1.png" alt="bad" width={70} height={90} />
                    <div className="bg-[#4BB213] text-white flex item-center justify-center py-[1px] px-[6px] rounded-full absolute -bottom-2 right-0">
                        <p className="object-cover font-black text-[12px]">✔</p>
                    </div>
                </div>
                <div className="flex flex-col items-center relative">
                    <Image src="/images/tips/child-too-far.png" alt="bad" width={75} height={95} />
                    <div className="bg-red-600 text-white flex item-center justify-center py-[1px] px-[6px] rounded-full absolute -bottom-1 right-0">
                        <p className="object-cover font-black text-[12px]">✖</p>
                    </div>
                </div>
            </div>
            <p className="mt-4 text-md">{t('tipsTwo')}</p>
          </div>
        </div>

        {/* Continue Button */}
        <button
          onClick={onClose}
          className="w-full bg-[#00214D] text-white rounded-xl py-3 mt-6 text-lg font-semibold"
        >
          {t('continue')}
        </button>
      </div>
    </div>
  );
}
